import React, { useEffect, useState } from "react";
import "./styles.scss";
import { FormHeader, CategoryCard, DropBox, Button } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewTags, CreateNewWidgets } from "../CreateNewItem";
import { getLanguage } from "../../utils/environment";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setTagsList, setSelectTag, setSelectWidget } from "./redux/actions";
import { deleteTag, getAllTags, getAllWidgets } from "./service/tags.service";
import { Store } from "react-notifications-component";
import TagWidgetCard from "../../components/tagWidgetCard";
import TagWidgetGroupCard from "../../components/tagWidgetGroupCard";
import { deleteWidgetNews } from "../news/service/news.service";
import { deleteWidget } from "../Tags/service/tags.service";

const lan = getLanguage();

const Widget = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [selectedNews, setSelectNews] = useState([]);
  const dispatch = useDispatch();

  const widgetList = useSelector((state) => state.widgetReducer.widgetList);

  const [formData, setFormData] = useState({
    status: {
      key: "status",
      label: "",
      size: "lg",
      placeholder: "Select Status",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const onClickRefresh = async () => {
    setIsLoading(true);
    await fetchData();
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const getList = await getAllWidgets();
      console.log("Get All Widgets : ", getList);

      if (getList?.data) {
        // dispatch(setTagsList(getList.data));
        setTagList(getList.data);
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Data", error);
    }
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-tags-wrapper">
        <div className="col-9 tags-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Tags",
              size: "md-md",
            }}
          />
          <div className={"hne-job-action-wrapper"}>
            <div className={"hne-jaw-input-wrapper"}>
              <div style={{ minWidth: "205px" }}>
                <DropBox
                  data={updateForm.status}
                  onChange={(e) => {
                    const updateForm = { ...formData };
                    updateForm["status"].value = e;
                    // setFormData(updateForm);
                    // dispatch(setCategoryDetails(e));
                  }}
                />
              </div>
            </div>
            <div className={"hne-jaw-action-wrapper"}>
              <Button
                data={{
                  btnName: "REFRESH",
                  buttonType: "border",
                  buttonSize: "sm x",
                  isLoading: isLoading,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  await onClickRefresh(e);
                }}
              />
            </div>
          </div>

          <div className="hne-body-wrapper">
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 300 }}
            >
              <div
                className="d-flex flex-column flex-wrap mt-2"
                style={{ gap: "8px" }}
              >
                {Array.isArray(tagList) && tagList.length > 0 ? (
                  tagList.map((item) => (
                    <div className="d-flex" key={item?.widget_id}>
                      <TagWidgetGroupCard
                        titleSi={item.widget_name}
                        titleId={item.widget_id}
                        tagId={item.widget_id}
                        edit={"Edit"}
                        delete={"Delete"}
                        onClickEdit={() => {
                          setTagList(item?.widget_id);
                          dispatch(setSelectWidget(item));
                        }}
                        isSelect={false}
                        Refresh={onClickRefresh}
                        onClickRemove={async () => {
                          setIsLoading(true);
                          try {
                            let response = await deleteWidget(item?.widget_id);
                            console.log("Delete Response : ", response);
                            if (response?.data) {
                              Store.addNotification({
                                title: "Success",
                                message: "Widget deleted successfully",
                                type: "success",
                                container: "top-right",
                                dismiss: {
                                  duration: 2000,
                                  onScreen: true,
                                },
                              });
                              await onClickRefresh();
                            }
                          } catch (error) {
                            console.log("Error deleting Widget", error);
                            Store.addNotification({
                              title: "Error",
                              message: "Failed to delete Widget",
                              type: "danger",
                              container: "top-right",
                              dismiss: {
                                duration: 2000,
                                onScreen: true,
                              },
                            });
                          }
                          setIsLoading(false);
                        }}
                      />
                    </div>
                  ))
                ) : (
                  <div className="error-message">No Widget Found</div>
                )}
              </div>
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className="col-3 Tags-right-side-wrapper">
          <CreateNewWidgets refresh={onClickRefresh} />
        </div>
      </div>
    </>
  );
};
export default withRouter(Widget);
